module.exports = __webpack_public_path__ + "static/team-24-3fd785abb9b7aa3028be4c427eaaac42.jpg";